import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import {
  IParaclinico,
  IHistorico,
  IEventoHistorico,
} from '../../paraclinicos/paraclinicos-page/interfaces/paraclinico.interface';

@Component({
  selector: 'app-historico-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './historico-modal.component.html',
})
export class HistoricoModalComponent implements OnInit {
  @Input() historico: IHistorico[] = [];
  @Input() paraclinicosDisponibles: IParaclinico[] = [];
  @Input() modoEdicion = false;
  @Input() modoEdicionHistorico = false;
  @Input() historicoParaEditar: IHistorico | null = null;
  @Input() indiceHistoricoEnEdicion: number | null = null;

  nuevoHistorico: IHistorico = { titulo: '', eventos: [] };
  indiceHistoricoSeleccionado: number | null = null;
  tituloSeleccionado = '';
  asociarParaclinico = false;
  paraclinicoSeleccionadoId: string | null = null;
  eventoEditandoParaclinico: number | null = null;
  paraclinicoTemporal: string | null = null;

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    if (this.modoEdicionHistorico && this.historicoParaEditar) {
      this.nuevoHistorico = {
        titulo: this.historicoParaEditar.titulo,
        eventos: this.historicoParaEditar.eventos.map((e) => ({ ...e })),
      };
    }
  }

  get tituloModal(): string {
    if (this.modoEdicionHistorico) {
      return 'Editar histórico';
    } else if (this.modoEdicion) {
      return 'Agregar eventos a: ' + this.tituloSeleccionado;
    }
    return 'Agregar histórico';
  }

  get subtituloModal(): string {
    if (this.modoEdicionHistorico) {
      return 'Modifica el título y los eventos del histórico.';
    } else if (this.modoEdicion) {
      return 'Agrega más eventos al grupo existente.';
    }
    return 'Captura el título y los eventos asociados.';
  }

  onTituloSeleccionadoChange(): void {
    if (this.indiceHistoricoSeleccionado !== null) {
      this.tituloSeleccionado = this.historico[this.indiceHistoricoSeleccionado].titulo;
    }
  }

  agregarEventoHistorico(): void {
    this.nuevoHistorico.eventos.push({ fecha: '', nombre: '', descripcion: '' });
  }

  eliminarEventoHistorico(index: number): void {
    this.nuevoHistorico.eventos.splice(index, 1);
  }

  puedeGuardar(): boolean {
    if (!this.nuevoHistorico.eventos.length) {
      return false;
    }

    // Validar que TODOS los eventos tengan fecha y nombre (campos requeridos)
    const todosEventosValidos = this.nuevoHistorico.eventos.every(evento =>
      evento.fecha && evento.fecha.trim() !== '' &&
      evento.nombre && evento.nombre.trim() !== ''
    );

    if (!todosEventosValidos) {
      return false;
    }

    if (this.modoEdicionHistorico) {
      return !!this.nuevoHistorico.titulo && this.indiceHistoricoEnEdicion !== null;
    } else if (this.modoEdicion) {
      return this.indiceHistoricoSeleccionado !== null;
    } else {
      return !!this.nuevoHistorico.titulo;
    }
  }

  guardarHistorico(): void {
    if (!this.puedeGuardar()) {
      return;
    }

    if (this.asociarParaclinico && this.paraclinicoSeleccionadoId) {
      const paraclinicoSeleccionado = this.paraclinicosDisponibles.find(
        (p) => p.id === this.paraclinicoSeleccionadoId
      );

      if (paraclinicoSeleccionado) {
        const ultimoEvento = this.nuevoHistorico.eventos[this.nuevoHistorico.eventos.length - 1];
        if (ultimoEvento) {
          ultimoEvento.paraclinico = {
            id: paraclinicoSeleccionado.id || '',
            backendId: paraclinicoSeleccionado.backendId,
            nombre: paraclinicoSeleccionado.nombre,
            tipo: paraclinicoSeleccionado.tipo || 'interno',
            fecha: paraclinicoSeleccionado.fecha,
            pdfUrl: paraclinicoSeleccionado.pdfUrl,
          };
        }
      }
    }

    this.modalController.dismiss({
      nuevoHistorico: this.nuevoHistorico,
      modoEdicion: this.modoEdicion,
      modoEdicionHistorico: this.modoEdicionHistorico,
      indiceHistoricoSeleccionado: this.indiceHistoricoSeleccionado,
      indiceHistoricoEnEdicion: this.indiceHistoricoEnEdicion,
    });
  }

  mostrarSelectorParaclinico(index: number): void {
    this.eventoEditandoParaclinico = index;
    this.paraclinicoTemporal = null;
  }

  aplicarCambioParaclinico(index: number): void {
    if (this.paraclinicoTemporal) {
      const paraclinicoSeleccionado = this.paraclinicosDisponibles.find(
        (p) => p.id === this.paraclinicoTemporal
      );

      if (paraclinicoSeleccionado && this.nuevoHistorico.eventos[index]) {
        this.nuevoHistorico.eventos[index].paraclinico = {
          id: paraclinicoSeleccionado.id || '',
          backendId: paraclinicoSeleccionado.backendId,
          nombre: paraclinicoSeleccionado.nombre,
          tipo: paraclinicoSeleccionado.tipo || 'interno',
          fecha: paraclinicoSeleccionado.fecha,
          pdfUrl: paraclinicoSeleccionado.pdfUrl,
        };
      }
    }
    this.eventoEditandoParaclinico = null;
    this.paraclinicoTemporal = null;
  }

  cancelar(): void {
    this.modalController.dismiss(null);
  }
}
